import { render, staticRenderFns } from "./UpdateNote.vue?vue&type=template&id=0de1b48e&"
import script from "./UpdateNote.vue?vue&type=script&lang=js&"
export * from "./UpdateNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports